import React from 'react'
import styles from './deleteModal.module.css';
import { Close, Deletemodal } from '../../../Svg';

const CancelModal = ({ isOpen, onClose, onDelete,heading }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button onClick={onClose} className={styles.closeButton}>  <Close onClick={onClose} /></button>
                <div className={styles.modalContentDetails}>
                    <div className={styles.modalHeader}>
                        <h2>Cancel order</h2>
                    </div>
                    <div className={styles.modalBody}>
                        <p>Do you want to cancel this order?</p>
                    </div>
                    <div className={styles.modalFooter}>
                        <button onClick={onClose} className={styles.cancelButton} >No</button>
                        <button onClick={onDelete} className={styles.deleteButton}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CancelModal;
